<div class="layout-wrapper">
  <lib-app-topbar></lib-app-topbar>
  <lib-app-topbar-bot></lib-app-topbar-bot>
  <div class="layout-main">
    <div class="layout-main-content">
      <div class="layout-content layout-content-no-menu evtMainGovBackground">
        <router-outlet></router-outlet>
      </div>
    </div>
    <ix-toast></ix-toast>
  </div>
  <lib-app-footer></lib-app-footer>
</div>
